var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Level as LevelModel } from '@/models/Level';
import PageHeader from '@/components/page-header/PageHeader';
import { RolesEnum } from '@/items/Roles';
let Level = class Level extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Level';
        this.level = new LevelModel();
        this.levelCache = {
            name: '',
            value: '',
            sequence: '',
        };
        this.isEditing = false;
    }
    mounted() {
        new LevelModel().find(this.$route.params.id).then((level) => {
            this.level = level;
        });
    }
    get breadcrumbs() {
        return [{ name: 'Levels', path: '/levels' }, { name: this.level.name || '', path: this.$route.path }];
    }
    createLevelCache() {
        Object.keys(this.levelCache).forEach((key) => {
            this.levelCache[key] = this.level[key];
        });
    }
    cancelEdit() {
        Object.keys(this.levelCache).forEach((key) => {
            this.level[key] = this.levelCache[key];
        });
        this.isEditing = false;
    }
    update() {
        this.level.update().then((level) => {
            this.level = level;
            this.isEditing = false;
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
};
Level = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Level);
export default Level;
